import { createSlice } from '@reduxjs/toolkit';

interface ProgressState {
  activeRequests: number;
  progress: number;
}

const initialState: ProgressState = {
  activeRequests: 0,
  progress: 0,
};

const progressSlice = createSlice({
  name: 'progress',
  initialState,
  reducers: {
    startRequest: (state) => {
      state.activeRequests += 1;
      state.progress = 10; // Start from 10% to show immediate feedback
    },
    updateProgress: (state, action) => {
      state.progress = action.payload;
    },
    endRequest: (state) => {
      state.activeRequests -= 1;
      if (state.activeRequests === 0) {
        state.progress = 0; // Ensure it reaches 0
      }
    },
  },
});

export const { startRequest, updateProgress, endRequest } = progressSlice.actions;
export default progressSlice.reducer;
